module.exports = __webpack_public_path__ + "static/media/rakan.07f90526.png";